import { BaseEntity } from "./base-entity.model";

export class TravelAdvisorProfile extends BaseEntity {
  handle: string;
  displayName: string;
  agency: string;
  bio: string;
  photoUrl: string;
  websiteUrl: string;
  instagramUrl: string;
  facebookUrl: string;
  phoneNumber: string;
  destinations: {
    nations: {
      name: string;
      all?: boolean;
      regions?: {
        name: string;
        all?: boolean;
        cities?: {
          name: string;
        }[]
      }[]
    }[]
  };

  constructor(object: object = {}) {
    super(object);
  }
}
